import type { Offer } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';
import logos from './supplierLogos';

type LoadingValue = 'eager' | 'lazy';
type Props = Pick<Offer, 'supplier'> & { className?: string; loading?: LoadingValue };

const supplierDisplayNames = displayValues.suppliers as Record<string, string>;

export const SupplierLogo = ({ supplier, className, loading = 'lazy' }: Props) => {
    const logoAttributes = logos()[supplier?.toLowerCase()];

    try {
        return logoAttributes ? (
            <img
                src={logoAttributes.src}
                height={logoAttributes.height}
                width={logoAttributes.width}
                loading={loading}
                className={className}
                alt={`${supplierDisplayNames[supplier]}`}
            />
        ) : (
            <span />
        );
    } catch (_e) {
        // missing image, ignore
        return <span />;
    }
};
